module.exports = __webpack_public_path__ + "static/media/ca.5916ba94.svg";